export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-camera-68466af465595977e2d0fa9091eb778d.svg";